<template>
  <v-container width="800px">
    <v-row>
      <v-col v-for="seccion in secciones" :key="seccion.sectionId" cols="12" sm="12">
        <v-row justify="center">
          <v-col cols="auto" md="6" sm="3">
            <v-btn max-height="117px" max-width="370px" min-height="117px" min-width="214px"
              :class="setColor(seccion.sectionId)" @click="redirectSection(seccion.nombre)">
              <div class="wrapText">{{ seccion.nombre }}</div>
            </v-btn>
          </v-col>
          <v-col cols="auto" md="6" sm="3" class="description">
            <p>{{ seccion.description }}</p>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
  </v-container>
</template>
<style>
p {
  text-align: justify;
  text-justify: inter-word;
}

.btn-darkblue {
  color: #FFFFFF !important;
  background-color: #005497 !important;
}

.btn-blue {
  color: #FFFFFF !important;
  background-color: #0092d0 !important;
}

.btn-info {
  color: #FFFFFF !important;
  background-color: #8d9296 !important;
}

.btn-warning {
  color: #FFFFFF !important;
  background-color: #ef8728 !important;
}

.wrapText {
  text-transform: capitalize;
  color: #FFFFFF !important;
  white-space: break-spaces !important;
  word-wrap: break-word !important;
  inline-size: 350px;
  overflow-wrap: break-word;
  font-size: 28px;
}

.description {
  font-size: 1.5em;
  text-align: justify;
  margin-top: 1em;
  margin-bottom: 1em;
}
</style>
<script>
import axios from "axios"

export default {
  data: () => ({
    secciones: {},
    clases: [
      { id: "1", color: "btn-darkblue" },
      { id: "2", color: "btn-blue" },
      { id: "3", color: "btn-info" },
      { id: "4", color: "btn-warning" },
    ],
  }),
  computed: {

  },
  mounted() {
    this.initiate()
  },
  methods: {
    initiate() {
      axios.get('/libraries/all')
        .then(response => {
          this.secciones = response.data.secciones
        })
        .catch(err => {
          console.error(err)
        })
    },
    redirectSection(name) {
      this.$router.push({ path: `/seccion?name=${name}` })
    },
    setColor(id) {
      return this.clases.find(c => { return c.id === id }).color
    }
  },
}
</script>